import { Spinner } from '@/components/generic';
import { ArrowDownBlueIcon } from '@/resources';

type PaginationArrowProps = {
  isFetchingNextPage: boolean;
  inView: boolean;
  className?: string;
};

export const PaginationArrow = ({
  isFetchingNextPage,
  inView,
  className = ''
}: PaginationArrowProps) => {
  return (
    <div className={`hidden flex-col items-center justify-center md:flex ${className}`}>
      {isFetchingNextPage ? (
        <div className='my-2 size-6'>
          <Spinner />
        </div>
      ) : inView ? null : (
        <div className='flex size-6 items-center justify-center'>
          <ArrowDownBlueIcon className='my-2 size-6' />
        </div>
      )}
    </div>
  );
};
